module.exports = __webpack_public_path__ + "static/fb-92a6cf67bedfa14ee1445accb0114812.png";